import { combineReducers } from 'redux';

import user from './user';
import buhtable from './buhtable';

const reducers = combineReducers({
    user,
    buhtable
});

export default reducers;


// WEBPACK FOOTER //
// ./src/_reducers/index.js